export default __webpack_public_path__ + "static/media/Temperature_white.e0e363f4.png";